import React from "react";
import { useUtilityStyles } from "./hooks/useUtilityStyles";
export var StyleBlock = function (props) { return (React.createElement("div", { className: useUtilityStyles(props === null || props === void 0 ? void 0 : props.styleOptions).utilities }, props === null || props === void 0 ? void 0 : props.children)); };
